import { withTranslation } from "react-i18next";

import React from 'react';
import { Link, } from 'react-router-dom';
import Pagination from "react-js-pagination";
import ProductsUpload from '../../Models/ProductsUpload';
import Products from '../../Models/Products';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import StarRatingComponent from 'react-star-rating-component';
import StarRatings from 'react-star-ratings';
import Common from "../../Models/Common";
var striptags = require('striptags');

class CategoriesShowProducts extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            activePage: 1,
            itemsCountPerPage: 10,
            pageRangeDisplayed: '',
            categories: [],
            allCategories: [],
            categoriesName: [],
            categoryProducts: [],
            allProducts: [],
            total: []
        };
        // this.getTotal();
        this.getAllCategories();
        this.getCategory();
        this.getAllProducts();
        this.getCategoriesName(this.props.id);
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.id !== this.props.id)
            this.getAllProducts();
    }

    getCategory() {
        ProductsUpload.getCategory().then(res => {
            this.setState({ categories: res.data.categories })
        })
    }

    getAllProducts() {
        let affId = JSON.parse(localStorage.getItem('aff-id'))
        if (affId > 0) {
            Products.getAffiliatorProductsList(this.props.id, 1).then(res => {
                if (res.data.status === 200) {
                    this.setState({ allProducts: res.data.payload, total: res.data.total, pageRangeDisplayed: this.state.pageRangeDisplayed, itemsCountPerPage: this.state.itemsCountPerPage })
                }
            })
        } else {
            Products.getProductsList(this.props.id, 1).then(res => {
                if (res.data.status === 200) {
                    this.setState({ allProducts: res.data.payload, total: res.data.total, pageRangeDisplayed: this.state.pageRangeDisplayed, itemsCountPerPage: this.state.itemsCountPerPage })
                }
            })
        }
    }

    getAllCategories() {
        Products.getProductsList(this.props.id, 1).then(res => {
            if (res.data.status === 200) {
                this.setState({ allCategories: res.data.cat_name })
            }
        })
    }

    getCategoriesName(id) {
        Products.getCategoryName(id).then(res => {
            if (res.data.status === 200) {
                this.setState({ categoriesName: res.data.payload })
            }
        })
    }

    getTotal() {
        Products.getProductsList(this.props.id, 1).then(res => {
            if (res.data.status === 200) {
                this.setState({ total: res.data })
            }
        })
    }


    handlePageChange(pageNumber) {

        let affId = JSON.parse(localStorage.getItem('aff-id'))
        if (affId > 0) {
            Products.getAffiliatorProductsList(this.props.id, pageNumber).then(res => {
                if (res.data.status === 200) {
                    this.setState({ allProducts: res.data.payload, total: res.data.total, pageRangeDisplayed: this.state.pageRangeDisplayed, itemsCountPerPage: this.state.itemsCountPerPage })
                }
            })
        } else {
            Products.getProductsList(this.props.id, pageNumber).then(res => {
                console.log(res.data)
                this.setState({ allProducts: res.data.payload })
                this.setState({ activePage: pageNumber, pageRangeDisplayed: this.state.pageRangeDisplayed, itemsCountPerPage: this.state.itemsCountPerPage, total: res.data.total });
            })
        }
    }

    toggle() {
        this.setState({ collapse: !this.state.collapse });
    }

    toggleAll() {
        this.setState(prevState => ({
            modal: !prevState.modal
        }));
    }

    sellerName(name, id) {
        if (!localStorage.getItem('info')) {
            return (
                <div className="">
                    <div style={{ cursor: 'pointer', color: '#007bff' }} className="" onClick={this.toggleAll.bind(this)}>{name}</div>
                    <Modal isOpen={this.state.modal} toggle={this.toggleAll.bind(this)} className={this.props.className}>
                        <ModalHeader toggle={this.toggleAll.bind(this)}></ModalHeader>
                        <ModalBody>
                            {this.props.t('0')}
                        </ModalBody>
                        <ModalFooter>
                            <Button color="danger" onClick={this.toggleAll.bind(this)}>{this.props.t('3')}</Button>
                        </ModalFooter>
                    </Modal>
                </div>
            )
        } else {
            return (
                <Link to={{ pathname: `/my-profile-view/users/${id}`, state: { id: id } }} style={{ textAlign: 'center', fontSize: '13px' }} className="">
                    {name}
                </Link>
            )
        }
    }

    details(details) {
        const renderHTML = (rawHTML) => React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } });
        if (details === null || details === '') {
            return (
                (details)
            )
        } else {
            return (
                renderHTML(details.substr(0, 120))
            )
        }
    }

    range() {
        if (this.state.total > 0) {
            return (
                <div className="some_of_total pl-3" >
                    {/* <span>{this.state.total}{this.props.t('4')} 1-{this.state.total} {this.props.t('6')}</span> */}
                </div>
            )
        } else {
            return (
                <div className="some_of_total pl-3" >
                    {/* <span>{this.state.total}{this.props.t('4')} 1-{this.state.total} {this.props.t('6')}</span> */}
                </div>
            )
        }
    }

    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        if (isMobile) {
            return (
                <div>
                    <div className=" large_fonts">
                        <div>
                            <div className="big_text guide_text" style={{ paddingBottom: '10px', width: '100%' }}>
                                {this.props.category_name}
                            </div>
                            {this.range()}
                            <div className="" >
                                {this.state.allProducts.map(pro =>
                                    <div className="" key={pro.id} >
                                        <div style={{ border: "1px solid #f4f2f0", padding: '2%' }}>
                                            <div className="row " >
                                                <div className="col-md-9 remember_text" >
                                                    <div className="mt-2 pb-2 row stars">
                                                        <div className="col-8">
                                                            {this.sellerName(pro.seller, pro.seller_id)}
                                                        </div>
                                                        <div className="col-4 text-center" >
                                                            <span>{parseInt(pro.price)}</span> {this.props.t('8')}
                                                        </div>
                                                    </div>
                                                    <Link to={{
                                                        pathname: `/categories-details/${pro.id}`,
                                                        state: { id: pro.id }
                                                    }}
                                                        style={{ textDecoration: "none" }}>
                                                        <span className="category-right"><b>{pro.title}</b></span><br />
                                                    </Link>
                                                    <span className="diff_font category-right">{pro.short_desc}</span>
                                                    <div className="product_description" style={{ fontSize: '12' }}>
                                                        {this.details(pro.long_desc)}
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <img src={Common.baseUrl+pro.img} alt="" height='100%' width='100%' style={{ objectFit: 'cover' }} />
                                                </div>
                                            </div>
                                        </div>
                                        <br />
                                    </div>
                                )}
                            </div>
                        </div>
                        {(() => {
                            if (this.state.allProducts.length < 10) {
                                return (
                                    <div></div>
                                )
                            } else {
                                return (
                                    <div className="row">
                                        <div className="col-md-4"></div>
                                        <div className="col-md-6 ml-5" style={{ fontSize: "15px" }}>
                                            <Pagination
                                                hideNavigation
                                                activePage={this.state.activePage}
                                                itemsCountPerPage={this.state.itemsCountPerPage}
                                                totalItemsCount={this.state.total}
                                                pageRangeDisplayed={this.state.pageRangeDisplayed}
                                                onChange={this.handlePageChange.bind(this)}
                                            />
                                        </div>
                                        <div className="col-md-2"></div>
                                    </div>
                                )
                            }
                        })()}

                    </div>
                </div>
            )
        }
        //For Desktop View
        else if (isDesktop) {
            return (
                <div>
                    <div className="container-fluid pl-4">
                        <div className=" large_fonts">
                            <div>
                                <div className="col-md-12" >
                                    <div className="guide_text" style={{ width: '100%' }}>
                                        {this.props.category_name}
                                    </div>
                                </div>
                                {this.range()}
                                <div className="custom_padding_dash" >
                                    {this.state.allProducts.map(pro =>
                                        //  var hexString = (item.id+521).toString(16);
                                        <div className="" key={pro.id} >
                                            <div className="" style={{ border: '1px solid #f4f2f0', padding: '12px' }}>
                                                <div className="row ">
                                                    <div className="col-md-9 remember_text">
                                                        <Link to={{
                                                            pathname: `/categories-details/${pro.id}`,
                                                            state: { id: pro.id }
                                                        }}
                                                            style={{ textDecoration: "none" }}>
                                                            <span className="category-right"><b>{pro.title}</b></span><br />
                                                        </Link>
                                                        <span className="diff_font category-right">{pro.short_desc}</span>
                                                        <div className="product_description" style={{ fontSize: '12' }}>
                                                            {this.details(pro.long_desc)}
                                                            {/* {renderHTML(pro.long_description)} */}
                                                        </div>
                                                        <div className="mt-1 col-md-12 stars">
                                                            <div className=" row ">
                                                                {this.sellerName(pro.seller, pro.seller_id)}
                                                                {/* </span> */}
                                                            </div>
                                                            {/* <div className="col-md-4">
                                                        <StarRatingComponent
                                                            name="rate1"
                                                            starCount={5}
                                                            value={pro.stars}
                                                        />
                                                    </div> */}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <img src={Common.baseUrl+pro.img} alt="" height='100' width='100%' style={{ objectFit: 'cover' }} />
                                                        <br />
                                                        <div className="mt-2" style={{ fontSize: '20px', textAlign: 'center' }}>
                                                            <span>{parseInt(pro.price)}</span> {this.props.t('8')}
                                                        </div>
                                                        {/* <div className="" style={{ textAlign: "left" }}>
                                                    <b>¥ {parseInt(pro.price)}</b>
                                                </div> */}
                                                    </div>
                                                </div>
                                            </div>
                                            <br />
                                        </div>
                                    )}
                                </div>
                            </div>
                            {(() => {
                                if (this.state.total < 10) {
                                    return (
                                        <div></div>
                                    )
                                } else {
                                    return (
                                        <div className="row">
                                            <div className="col-md-4"></div>
                                            <div className="col-md-6 ml-5" style={{ fontSize: "15px" }}>
                                                <Pagination
                                                    hideNavigation
                                                    activePage={this.state.activePage}
                                                    itemsCountPerPage={this.state.itemsCountPerPage}
                                                    totalItemsCount={this.state.total}
                                                    pageRangeDisplayed={this.state.pageRangeDisplayed}
                                                    onChange={this.handlePageChange.bind(this)}
                                                />
                                            </div>
                                            <div className="col-md-2"></div>
                                        </div>
                                    )
                                }
                            })()}

                        </div>
                    </div>
                </div >
            )
        }
    }
}
export { CategoriesShowProducts }


 CategoriesShowProducts = withTranslation('src_Components_Categories_CategoriesShowProducts')(CategoriesShowProducts);
